import { GET_OWNER, GET_TOKEN, SET_TOKEN } from "redux/TypeConstant"

const OwnerReducer=(state=['normal-staff','super-admin'],action)=>{
    switch(action.type)
    {
        
        case GET_OWNER:
            return state 

            default :
            return state
    }

}

export default OwnerReducer